import React from "react";
import {autobind} from "core-decorators";
import {Button, Tooltip} from "antd";
import {FaFileUpload} from "react-icons/fa";
import {Link} from "react-router-dom";
import {inject, observer} from "mobx-react";

import {VersionablePieceStatuses} from "@/shared/constants";
import {paths} from "@/routes";
import {PiecesQuery} from "@/graphql/types";
import Store from "@/stores";

export interface INewVersionActionProps {
  piece: PiecesQuery["pieces"][0];
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class NewVersionAction extends React.Component<INewVersionActionProps> {
  public render() {
    const {piece, store} = this.props;
    const {session} = store!;
    let tooltip: string = "Upload New Score Version";
    let disabled: boolean = false;

    if (!session.isEnsembleConductor) return null;
    else if (!VersionablePieceStatuses.find((status) => status === piece.status)) disabled = true;
    else if (piece.catalog_piece_id !== null) {
      disabled = true;
      tooltip += " (unavailable for catalog pieces)";
    } else if (!(session.ownerHasPlanEnsemble || session.ownerHasPlanPro)) {
      disabled = true;
      tooltip += " (unavailable for ensemble owners not subscribed to Pro o Ensemble plan)";
    }

    return (
      <Tooltip title={tooltip} placement="topLeft" arrowPointAtCenter>
        {disabled ? (
          <Button type="link" shape="circle" size="small" disabled>
            <FaFileUpload />
          </Button>
        ) : (
          <Link to={paths.pieceNewVersion(piece.versioned_piece_id || piece.id)}>
            <Button type="link" shape="circle" size="small">
              <FaFileUpload />
            </Button>
          </Link>
        )}
      </Tooltip>
    );
  }
}
